<template>
	<section class="visit-wrap">
		<section class="mark" id="visitMark" @click="close"></section>
		<section class="visit-list" id="visitList">
			<h1>진료일 선택</h1>
			<div class="tbl-wrap">
				<div class="table-head">
					<table>
						<colgroup>
							<col width="10px" />
							<col width="16%" />
							<col width="15%" />
							<col width="14%" />
							<col width="12%" />
							<col width="14%" />
							<col width="14%" />
							<col width="14%" />
							<col width="10px" />
						</colgroup>
						<thead>
							<tr>
								<th></th>
								<th>진료일시</th>
								<th>최대처방일</th>
								<th>처방약 남은일</th>
								<!-- <th>처방종료일<br />까지 남은날짜</th> -->
								<th>초/재</th>
								<th>입원/외래</th>
								<th>보험구분</th>
								<th>의사명</th>
								<th></th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="table-body">
					<table>
						<colgroup>
							<col width="10px" />
							<col width="16%" />
							<col width="15%" />
							<col width="14%" />
							<col width="12%" />
							<col width="14%" />
							<col width="14%" />
							<col width="14%" />
							<col width="10px" />
						</colgroup>
						<tbody>
							<tr v-for="(item, idx) in visitItems" :key="idx" @click="trClick(item)" class="word-break">
								<!-- @click="clickVisitDetail(item)"> -->
								<template v-if="visitItems.length > 0">
									<td></td>
									<td>
										<template v-if="item.clinicYmd.substr(4, 1) === '.'"> {{ item.clinicYmd.substr(0, 4) }}-{{ item.clinicYmd.substr(5, 2) }}-{{ item.clinicYmd.substr(8, 2) }} </template>
										<template v-else>
											{{ item.clinicYmd }}
										</template>
									</td>
									<td>{{ item.maxOrder }}</td>
									<td>{{ item.leftDays }}</td>
									<td>{{ item.firstVisit }}</td>
									<td>{{ item.adm }}</td>
									<td>{{ item.insrGb }}</td>
									<td>{{ item.doctorNm }}</td>
									<td></td>
								</template>
								<template v-else>
									<td colspan="9" class="nodata">조회 결과가 없습니다</td>
								</template>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<section class="close" @click="close">닫기</section>
		</section>
	</section>
</template>

<script>
import { popCloseAndScrollAuto } from '@/utils/UtilPopup';

export default {
	props: {
		visitItems: {
			type: Array,
			require: false
		}
	},
	data() {
		return {
			item: null
		};
	},
	methods: {
		trClick(item) {
			// TODO :: 진료일 클릭 시, 해당 진료일의 내용이 나와야하는 동작

			console.log(item);
			this.$emit('sendItem', item);

			this.close();
		},
		close() {
			popCloseAndScrollAuto('#visitMark', '#visitList');
		}
	}
};
</script>

<style scoped>
.mark {
	position: fixed;
	visibility: hidden;
	overflow: auto;
	z-index: 100000;
	inset: 0px;
	background-color: rgba(0, 0, 0);
	transition: all 0.3s ease 0s;
}
.visit-list {
	position: fixed;
	left: 50%;
	top: 50%;
	width: 90%;
	height: 80%;
	transform: translate(-50%, -50%);
	padding: 30px 30px 70px;
	opacity: 0;
	visibility: hidden;
	overflow: hidden;
	z-index: 100001;
	background-color: #fff;
	border-radius: 15px;
	transition: all 0.3s ease 0s;
}
h1 {
	font-family: 'NotoBold';
	font-size: 2.5rem;
	margin: 0 0 25px 10px;
}
.tbl-wrap {
	height: calc(100% - 70px - 37px);
	border: 1px solid #e8e8e8;
	border-radius: 6px;
}
.tbl-wrap .table-head {
	border-bottom: 1px solid #e8e8e8;
}
.tbl-wrap .table-body {
	height: calc(100% - 56px);
	overflow: auto;
}
.tbl-wrap .table-body tbody tr:nth-child(odd) td {
	background: #fafafa;
}
th {
	padding: 15px 0;
	text-align: center;
	font-size: 1.6rem;
}
td {
	padding: 25px 0;
	font-size: 1.6rem;
	text-align: center;
}
.close {
	position: absolute;
	width: 100%;
	height: 70px;
	bottom: 0px;
	background-color: #e5e5e5;
	left: 0;
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
	text-align: center;
	vertical-align: middle;
	line-height: 70px;
	font-size: 2.2rem;
	color: var(--button-color-gray);
	font-weight: 700;
}
.word-break {
	word-break: break-all;
}
</style>
